// import axios from "axios";

export default {
  namespaced: true,
  state: {
    token: null,
    import: {}
  },
  getters: {
    providerToken: (state) => state.token,
    providerImport: (state) => state.import
  },
  mutations: {
    setProviderImport: (state, importedObj) => (state.import = importedObj),
    unsetProviderImport: (state) => (state.import = null)
  }
};